import api from '../../fetch/api'
// import apiD from '../../fetch/api - id'

const state = {
  area: true,
  stractMark: [],
  ToPosition: [],
  ToPositionM: [],
  cod: '310104',
  numberTitle: [
    {name: '公证处', number: 21},
    {name: '办证点', number: 35}
  ],
  zoneList: [
    {name: '东方公证处', number: 46},
    {name: '浦东公证处', number: 3},
    {name: '徐汇公证处', number: 4},
    {name: '黄埔公证处', number: 12},
    {name: '新黄埔公证处', number: 2},
    {name: '卢湾公证处', number: 2},
    {name: '长宁公证处', number: 2},
    {name: '静安公证处', number: 4},
    {name: '闸北公证处', number: 4},
    {name: '杨浦公证处', number: 4},
    {name: '虹口公证处', number: 3},
    {name: '闵行公证处', number: 7},
    {name: '东方公证处', number: 4},
    {name: '浦东公证处', number: 3},
    {name: '徐汇公证处', number: 4},
    {name: '黄埔公证处', number: 12},
    {name: '新黄埔公证处', number: 2},
    {name: '卢湾公证处', number: 2},
    {name: '长宁公证处', number: 2},
    {name: '静安公证处', number: 4},
    {name: '闸北公证处', number: 4},
    {name: '杨浦公证处', number: 4},
    {name: '虹口公证处', number: 3},
    {name: '闵行公证处', number: 7},
    {name: '崇明公证处', number: 2}
  ],
  zoneDetail: {
    name: '东方公证处',
    code: 209004419855,
    address: '上海市静安区丹凤路598号',
    todaynumber: 56,
    allnumber: 565,
    personnel: 56,
    company: 8,
    personnelList: [
      {name: '陈美英1', number: 1805951518181},
      {name: '陈美英2', number: 1805951518181},
      {name: '陈美英3', number: 1805951518181},
      {name: '陈美英4', number: 1805951518181},
      {name: '陈美英5', number: 1805951518181},
      {name: '陈美英1', number: 1805951518181},
      {name: '陈美英2', number: 1805951518181},
      {name: '陈美英3', number: 1805951518181},
      {name: '陈美英4', number: 1805951518181},
      {name: '陈美英5', number: 1805951518181}
    ],
    companyList: [
      {name: '001', peop: '陈梅英', server: '学历学位公证', swite: true},
      {name: '002', peop: '陈梅英', server: '学历学位公证', swite: true},
      {name: '003', peop: '陈梅英', server: '学历学位公证', swite: true},
      {name: '004', peop: '陈梅英', server: '学历学位公证', swite: true},
      {name: '005', peop: '陈梅英', server: '学历学位公证', swite: false},
      {name: '006', peop: '陈梅英', server: '学历学位公证', swite: false}
    ]
  },
  companyDetailList: {
    name: '东方公证处（办证室001）',
    message: {
      name: '陈莹莹',
      number: 121515151515615,
      allNum: 12,
      finNum: 11
    },
    list: [
      {
        time: '15:56',
        matter: '赠与公证',
        name: '张三',
        code: '(2017) 沪字第012号',
        finish: true
      },
      {
        time: '15:56',
        matter: '赠与公证',
        name: '张三',
        code: '(2017) 沪字第012号',
        finish: false
      },
      {
        time: '15:56',
        matter: '赠与公证',
        name: '张三',
        code: '(2017) 沪字第012号',
        finish: false
      },
      {
        time: '15:56',
        matter: '赠与公证',
        name: '张三',
        code: '(2017) 沪字第012号',
        finish: false
      },
      {
        time: '15:56',
        matter: '赠与公证',
        name: '张三',
        code: '(2017) 沪字第012号',
        finish: false
      }
    ]
  },
  personnelDetail: {
    name: '王大壮',
    codeNumber: '12151523151535123',
    company: '上海市东方公证处',
    goOut: {
      matter: '金融业公证',
      applicant: '张三',
      address: '上海市徐汇区齐来大厦'
    },
    dynamic: [
      {time: '昨天10:00', dynamic: '申请外出'},
      {time: '今天10:00', dynamic: '申请外出通过'},
      {time: '今天11:12', dynamic: '到达核准地点'},
      {time: '今天11:20', dynamic: '开始受理，生成核验码'},
      {time: '今天11:25', dynamic: '完成人脸识别'},
      {time: '今天11:30', dynamic: '完成材料收集'},
      {time: '今天11:40', dynamic: '正在进行谈话告知'}
    ]
  },
  personnelList: [
    {swite: false, name: '虹口公证处', number: 46, list: [{name: '王二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '浦东公证处', number: 3, list: [{name: '张三', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '徐汇公证处', number: 4, list: [{name: '王二1', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '黄埔公证处', number: 12, list: [{name: '王二2', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '新黄埔公证处', number: 2, list: [{name: '王3二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '卢湾公证处', number: 2, list: [{name: '王4二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '长宁公证处', number: 2, list: [{name: '王5二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '静安公证处', number: 4, list: [{name: '王6二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '闸北公证处', number: 4, list: [{name: '王7二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '杨浦公证处', number: 4, list: [{name: '王8二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '虹口公证处', number: 3, list: [{name: '王9二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '闵行公证处', number: 7, list: [{name: '王2二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]},
    {swite: false, name: '东方公证处', number: 45, list: [{name: '王5二', state: '外出'}, {name: '王二', state: '外出'}, {name: '王二', state: '外出'}]}
  ]
}

const getters = {
  stractMark: state => {
    return state.stractMark.filter(stractMark => stractMark.level !== 'City')
  },
  ToPosition: state => state.ToPosition,
  ToPositionM: state => state.ToPositionM,
  numberTitle: state => state.numberTitle,
  zoneList: state => state.zoneList,
  zoneDetail: state => state.zoneDetail,
  companyDetailList: state => state.companyDetailList,
  personnelDetail: state => state.personnelDetail,
  personnelList: state => state.personnelList,
  area: state => state.area
}

const actions = {
  // 初始化
  getMark ({commit}) {
    let param = `&zonecode=${state.cod}`
    api.getStreetMark(param).then(res => {
      commit('goStrtt', res)
    })
  },
  getListaa ({commit}) {
    commit('getList')
  },
  AgetPresListShow ({commit}, iner) {
    commit('getpresListShow', iner)
  },
  AgetBack ({commit}, iner) {
    commit('getBack', iner)
  }
}

const mutations = {
  goStrtt (state, res) {
    state.stractMark = res
  },
  getList (state) {
    state.zoneList = []
  },
  getpresListShow (state, iner) {
    if (state.personnelList[iner].swite === false) {
      state.personnelList.map((n) => {
        n.swite = false
      })
      state.personnelList[iner].swite = true
    } else {
      state.personnelList[iner].swite = false
    }
  },
  // 返回按钮
  getBack (state, iner) {
    state.area = iner
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/datafn.js